import React, { useContext } from 'react';
import { UpgradeContext } from 'components/brikks/home/Upgrade/components/UpgradeModal/index';
import { ProceedButton } from 'components/form-elements/buttons/ProceedButton';
import { MultiStepContext } from 'components/MultiStep';
import styles from './styles.module.scss';
import { advancedMaintenance, MEASURES } from './helper';

export const ItemSelectButton = ({ maintenanceItem }) => {
  const { setSelectedSurface } = useContext(UpgradeContext);
  const { onNextStep } = useContext(MultiStepContext);

  const onSelectSurface = maintenanceItem => {
    onNextStep();
    setSelectedSurface(maintenanceItem);
  };

  const isSandingMeasure = maintenanceItem.measure === MEASURES.Sanded;

  return (
    <div className={styles.ItemSelectButton}>
      <div className={styles.content}>
        {(!isSandingMeasure || (isSandingMeasure && !advancedMaintenance(maintenanceItem.plannedDate)))
          && (
            <a href="#maintenanceProducts">
              <ProceedButton onClick={() => onSelectSurface(maintenanceItem)}>
                <ProceedButton.CircledArrow light />
              </ProceedButton>
            </a>
          )}
      </div>
    </div>
  );
};
